import {
  ACTION_LOAD_XCARD_INIT__REQUEST,
  ACTION_LOAD_XCARD_INIT__SUCCESS,
  ACTION_LOAD_XCARD_INIT__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_XCARD_INIT__REQUEST:
    case ACTION_LOAD_XCARD_INIT__SUCCESS:
      return null;

    case ACTION_LOAD_XCARD_INIT__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
